import angular from "angular"

angular
  .module("fichaAlumnoModule")
  .controller("FormularioAlertaController", FormularioAlertaController)
  .controller("FormularioEliminarAlertasController", FormularioEliminarAlertasController)
  .controller("FormularioAlertaEstadoController", FormularioAlertaEstadoController)

FormularioAlertaController.$inject = [
  "$scope",
  "$mdDialog",
  "TipoAlertaService",
  "UserService",
  "saveCallback"
]
function FormularioAlertaController(
  $scope,
  $mdDialog,
  TipoAlertaService,
  UserService,
  saveCallback
) {
  var self = $scope
  self.isLoading = false
  TipoAlertaService.get().$promise.then(function(data) {
    self.tipo_alertas = data.results
  })

  UserService.get().$promise.then(function(data) {
    self.responsables = data.results
  })

  self.notificarResponsable = true

  self.comentario = ""

  self.agregarAlerta = function() {
    var post_data = {
      tipo_alerta_id: self.selectedTipoAlerta,
      responsable_id: self.selectedResponsable,
      comentario: self.comentario,
      notificar_responsable: self.notificarResponsable
    }

    self.isLoading = true
    saveCallback(post_data, function() {
      self.isLoading = false
      self.closeFormulario()
    })
  }

  self.cancelar = function() {
    self.closeFormulario()
  }

  self.closeFormulario = function() {
    $mdDialog.hide()
  }
}

FormularioEliminarAlertasController.$inject = ["$scope", "$mdDialog", "saveCallback"]
function FormularioEliminarAlertasController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.eliminarAlertas = function() {
    console.log("alertas eliminadas")
    saveCallback()
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

FormularioAlertaEstadoController.$inject = [
  "$scope",
  "$mdDialog",
  "DTOptionsBuilder",
  "EstadoAlertaService",
  "saveCallback",
  "models"
]
function FormularioAlertaEstadoController(
  $scope,
  $mdDialog,
  DTOptionsBuilder,
  EstadoAlertaService,
  saveCallback,
  models
) {
  var self = $scope

  self.rows = models

  self.estados = []

  EstadoAlertaService.get().$promise.then(function(data) {
    self.estados = data.results
  })

  for (var i = 0; i < self.rows.length; i++) {
    self.rows[i].estado_nuevo_id = self.rows[i].estado_id
  }

  self.dtOptions = DTOptionsBuilder.newOptions()
    .withLanguage({
      sProcessing: "Procesando...",
      sLengthMenu: "Mostrar _MENU_ registros",
      sZeroRecords: "No se seleccionaron registros",
      sEmptyTable: "No se seleccionaron registros",
      sInfo: "_START_ a _END_ de _TOTAL_",
      sInfoEmpty: "",
      sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
      sInfoPostFix: "",
      sSearch: "",
      sUrl: "",
      sInfoThousands: ".",
      sLoadingRecords: "Cargando...",
      oPaginate: {
        sFirst: "|<",
        sLast: ">|",
        sNext: ">",
        sPrevious: "<"
      },
      oAria: {
        sSortAscending: ": Activar para ordenar la columna de manera ascendente",
        sSortDescending: ": Activar para ordenar la columna de manera descendente"
      }
    })
    .withPaginationType("simple")
    .withDisplayLength(25)
    .withOption("scrollY", "150px")
    .withOption("scrollX", "100%")
    // .withDOM('trp');
    .withDOM('<"menu-imp-exp">t')

  self.confirmar = function() {
    saveCallback(self.rowsDirty())
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }

  self.rowsDirty = function() {
    var dirty = []
    for (var i = 0; i < self.rows.length; i++) {
      if (self.rows[i].estado_nuevo_id !== self.rows[i].estado_id) {
        dirty.push({ id: self.rows[i].id, estado_id: self.rows[i].estado_nuevo_id })
      }
    }
    return dirty
  }
}
